import { Button } from '@talentmesh/ui/components/button';
import { DialogFooter } from '@talentmesh/ui/components/dialog';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { useState } from 'react';
import UIStrings from '@/Utils/UIStrings';

export interface AssessmentResetDialogActionsProps {
    onConfirm: () => Promise<void>;
    onCancel: () => void;
}

const AssessmentResetDialogActions = ({ onConfirm, onCancel }: AssessmentResetDialogActionsProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    return (
        <DialogFooter className="gap-2 sm:justify-end">
            <Button variant="outline" disabled={loading} onClick={onCancel}>
                {UIStrings.Cancel}
            </Button>
            <Button
                size="lg"
                disabled={loading}
                onClick={async () => {
                    setLoading(true);
                    try {
                        await onConfirm();
                        onCancel();
                    } finally {
                        setLoading(false);
                    }
                }}
            >
                {loading && <Spinner data-icon="inline-start" />}
                {UIStrings.ResetAssessment}
            </Button>
        </DialogFooter>
    );
};

export default AssessmentResetDialogActions;
